import React from 'react';
import PopupContainer from '@components/commons/popup/container/PopupContainer';
import EndingCard, { IEndingCard } from './EndingCard';

const EndingPopup = ({ ending, onClose, isShowButton }: IEndingCard) => {
  return (
    <PopupContainer>
      <EndingCard
        ending={ending}
        onClose={onClose}
        isShowButton={isShowButton}
        isPopup={true}
      />
    </PopupContainer>
  );
};

export default EndingPopup;
